import styled from 'styled-components';
import { Text } from '@zillow/constellation';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.main<{ loading: boolean }>`
  padding: 16px;
  padding-bottom: 60px;
  max-width: 1280px;
  width: 100%;
  ${({ loading }) => (loading ? 'opacity: 50%;' : '')}
`;

export const LastUpdatedDate = styled(Text)<{ alignLeft: boolean }>`
  text-align: ${({ alignLeft }) => (alignLeft ? 'left' : 'right')};
  margin-top: -8px;
`;

export const FlexList = styled.ul`
  display: flex;
  flex-flow: row wrap;
  gap: 24px;
`;
